import { render } from "./arrow-left.svg?vue&type=template&id=29aeadca"
const script = {}
script.render = render

export default script